import { CircleCheck, TriangleAlert } from "lucide-react"

import type { AbsenceReviewUiStore } from "@/lib/stores/absence-review-ui-store"

import { FadeIn } from "@/components/shared/fade-in"
import { StatusAlert } from "@/components/shared/status-alert"
import { useReviewMessage } from "@/lib/stores/absence-review-ui-store"

export function ReviewMessageAlert({ store }: { store: AbsenceReviewUiStore }) {
  const message = useReviewMessage(store)

  if (!message) {
    return null
  }

  if (message.tone === "error") {
    return (
      <FadeIn duration={0.18}>
        <StatusAlert tone="danger">
          <div className="flex items-start gap-2">
            <TriangleAlert className="size-4 shrink-0" />
            <span>{message.text}</span>
          </div>
        </StatusAlert>
      </FadeIn>
    )
  }

  return (
    <FadeIn duration={0.18}>
      <StatusAlert tone="success">
        <div className="flex items-start gap-2">
          <CircleCheck className="size-4 shrink-0" />
          <span>{message.text}</span>
        </div>
      </StatusAlert>
    </FadeIn>
  )
}
